import type { ApiParent, ApiSitter } from '@app/packages/api/v2/types/entities'

import { profileUserSelector } from '@app/store/slices/profile'
import { createThunk } from '@app/store/thunk'

import { callV2Api } from './api'

export function fetchTrusted() {
  return createThunk<Promise<{ data: (ApiParent | ApiSitter)[] }>>(async (dispatch, getState) => {
    const { getParentsTrusting } = await import('@app/packages/api/v2/actions/parents')
    const { getSittersTrusted } = await import('@app/packages/api/v2/actions/sitters')
    const accountType = profileUserSelector(getState())?.account_type
    if (accountType === 'parent') return await dispatch(callV2Api(getSittersTrusted()))
    if (accountType === 'sitter') return await dispatch(callV2Api(getParentsTrusting()))
    throw new Error(`Nobody is trusted by a ${accountType ?? 'missing'} profile — the callers exclude that case`)
  })
}
